import RouteNotFound from '@pages/route-not-found';
import { PlanGuardProps } from '@shared/types/components/role/plan-guard.types';
import { hasPlanAccess } from '@shared/utils/roles/has-plan-access.helper';

export const PlanGuard = ({ children, plans }: PlanGuardProps) => {
  if (!plans) return children;
  const [hasAccess] = hasPlanAccess(plans);
  return hasAccess ? children : <RouteNotFound />;
};
